export const MODAL_KEY = Object.freeze({
  ADD_EXCERCISES: 'add-exercises',
  ADD_LESSONS: 'add-lessons',
  ADD_COURSES: 'add-courses',
  ADD_INSTITUTIONS: 'add-institutions',
  DELETE_EXERCISE: 'delete-exercise',
  ADD_LESSON: 'add-lesson',
  DELETE_LESSON: 'delete-lesson',
  DELETE_COURSE: 'delete-course',
  DELETE_TRAINER: 'delete-trainer',
  DELETE_INSTITUTION: 'delete-institution',
  DELETE_LEARNER: 'delete-learner',
  CREATE_CLASS: 'create-class',
  REMOVE_MEMBER: 'remove-member',
  DELETE_CLASS: 'delete-class',
  DELETE_LESSON_IN_CLASS: 'delete-lesson-in-class',
  LESSON_INFO: 'lesson-info',
  DELETE_FUNCTIONAL_TEST: 'delete-functional-test',
  DELETE_ASSESSMENT: 'delete-assessment',
  WARNING_ASSESSMENT: 'warning-assessment',
  UPDATE_ASSESSMENT: 'update-assessment',
  VIEW_NOTE: 'view-note',
  CREATE_LEARNER: 'create-learner',
  DELETE_ADMIN: 'delete-admin',
  ADD_STATION: 'add-station',
  IMPORT_LEARNER: 'import-learner',
  SHOW_VIDEO: 'show-video',
  CLASS_ABSENT: 'class-absent',
  LEVEL_LESSON: 'level-lesson',
  END_REPEAT: 'end-repeat',
  EDIT_RECURRING_EVENT: 'edit-recurring-event',
  EDIT_RECURRING_NOT_UPDATED_EVENT: 'edit-recurring-not-updated-event',
  DELETE_RECURRING_EVENT: 'delete-recurring-event',
  DELETE_RECURRING_NOT_UPDATED_EVENT: 'delete-recurring-not-updated-event',
  QR_CODE: 'qr-code',
});
